import React from 'react';
export const ModalContext = React.createContext([
    {
        showModal: false,
        onModalSubmit: undefined,
        title: '',
        body: undefined,
        submitBtnText: '',
        submitBtnClassName: '',
        cancelBtnText: '',
        cancelBtnClassName: '',
        submitBtnPosition: 'right',
        addClassnameBody: '',
        addHeaderelement: undefined,
        addHeaderClassName: '',
        modalWithForm: false,
    },
    () => {
        return;
    },
]);
